import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getUserInfoKnoOrganisations = (state: IRootState) => state.userInfo.knoOrganisations;
export const getUserInfoOrganisationsPageCount = (state: IRootState) => state.userInfo.organisationsPageCount;
export const getUserInfoOrganisationsPage = (state: IRootState) => state.userInfo.organisationsPage;
export const getUserInfoOrganisationsTotalCount = (state: IRootState) => state.userInfo.organisationsTotalCount;
export const getUserInfoOrganisationsParentId = (state: IRootState) => state.userInfo.organisationsParentId;
export const getUserInfoOrganisationsSearchQuery = (state: IRootState) => state.userInfo.organisationsSearchQuery;
export const getUserInfoOrganisationsSearchCriteria = (state: IRootState) => state.userInfo.organisationsSearchCriteria;
export const getUserInfoOrganisationsAdminLevelCode = (state: IRootState) => state.userInfo.organisationsAdminLevelCode;
export const getUserInfoIsErvk = (state: IRootState) => state.userInfo.isErvk;

const getUserInfoProsecutorOrganizations = (state: IRootState) => state.userInfo.prosecutorOrganizations;

export const getUserInfoProsecutorOrganizationsData = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).data;
export const getUserInfoProsecutorOrganizationsDistrictId = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).districtId;
export const getUserInfoProsecutorOrganizationsSearchQuery = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).searchQuery;
export const getUserInfoProsecutorOrganizationsParentId = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).parentId;
export const getUserInfoProsecutorOrganizationsSearchOgrn = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).searchOgrn;
export const getUserInfoProsecutorOrganizationsPage = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).page;
export const getUserInfoProsecutorOrganizationsPageCount = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).pageCount;
export const getUserInfoProsecutorOrganizationsTotalCount = (state: IRootState) =>
  getUserInfoProsecutorOrganizations(state).totalCount;
export const getUserInfoCurrentFunctionsModalId = (state: IRootState) => state.userInfo.currentFunctionsModalId;
export const getUserInfoHighlightedSelectedOrganisations = (state: IRootState) =>
  state.userInfo.highlightedSelectedOrganisations;

export const getUserInfoProsecutorOrganisationByKno = (state: IRootState) => state.userInfo.prosecutorOrganisationByKno;
